import { oc } from "@orpc/contract";
import { z } from "zod";

const CustomerContactTagSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

const CustomerContactSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  title: z.string().nullable(),
  isPrimary: z.boolean(),
  originMetadata: z.record(z.string(), z.unknown()).nullable(),
  tags: z.array(CustomerContactTagSchema),
});

export const arCustomerContactsContracts = {
  list: oc
    .input(z.object({ customerId: z.string().uuid() }))
    .output(z.object({ contacts: z.array(CustomerContactSchema) }))
    .route({ method: "GET" }),
} as const;
